import { ConfirmDialog } from '@/shared/components/confirm-dialog'

interface AccountDeactivateConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

/** Fixed-copy wrapper: warning shown when the Active switch of an active
 * account is turned off (UC-080). */
export function AccountDeactivateConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
}: AccountDeactivateConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Are you sure you want to deactivate this account?"
      description="Once deactivated, the account will stop receiving data and later reactivation may lead to inconsistencies in your data."
      confirmLabel="Deactivate"
      confirmVariant="destructive"
      onConfirm={onConfirm}
    />
  )
}
